var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { OrderUserBy } from '@snapaddy/snapaddy-types/common';
import { Component } from 'angular-ts-decorators';
import { broadcastOrganizationSwitch } from '../shared/organization-switch';
import { isOrganizationMoveRequiresSwitchError } from '../shared/is-organization-move-requires-switch-error';
import { isSupportAccessDeniedError } from '../shared/is-support-access-denied-error';
import { isOrganizationSupportAccessRevoked, } from '../shared/is-organization-support-access-revoked';
import { RoleFilter } from './role-filter';
let currentOrganization = '';
function createNewEmptyViewModel() {
    return {
        user: '',
        organization: '',
        is_deleted: false,
        account_locked: false,
        unsuccessful_login_attempts: 0,
        last_login: '',
        licenses: [],
    };
}
let UserController = class UserController {
    $scope;
    $timeout;
    backendService;
    organizationService;
    userService;
    users = [];
    orgas = [];
    currentPage = 0;
    page_size = 25;
    filter = '';
    roleFilter = new RoleFilter();
    max_pages = 1;
    filtered_user_count = 0;
    order_criteria = OrderUserBy.USER_NAME_ASC;
    modalOrgaFilter = '';
    isLoading = true;
    orgasLoading = false;
    modalModel = createNewEmptyViewModel();
    // Minification-safe CI injections, everything @Inject()ed somewhere must be mentioned here:
    static $inject = ['$scope', '$timeout', 'BackendService', 'OrganizationService', 'UserService'];
    constructor($scope, $timeout, backendService, organizationService, userService) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.backendService = backendService;
        this.organizationService = organizationService;
        this.userService = userService;
        this.setup();
    }
    init() {
        this.updateUsers(0);
    }
    async filterOrgas() {
        this.orgasLoading = true;
        try {
            // We only trigger a search when we have more than three characters to reduce database load
            if (this.modalOrgaFilter.length >= 3) {
                this.orgas = (await this.organizationService.getOrganizations(0, // Page
                50, // Page-Size (Limit)
                this.modalOrgaFilter, // Filter
                false, // encodeIds
                false, // onlyOrga
                false)).orgas;
                this.orgas.sort((a, b) => (b.current_user_count || 0) - (a.current_user_count || 0));
                if (this.orgas.length > 0) {
                    this.modalModel.organization = this.orgas[0].organization_id;
                }
            }
            else {
                // Reset back to defaults
                this.orgas = [];
                this.modalModel.organization = currentOrganization;
            }
        }
        finally {
            this.orgasLoading = false;
        }
        // Apply changes to view
        this.$timeout(() => (this.$scope['modalModel'] = this.modalModel));
    }
    updateUsers(page) {
        this.isLoading = true;
        localStorage.setItem('account_user_page_size', String(this.page_size));
        localStorage.setItem('account_user_filter', this.filter);
        localStorage.setItem('account_user_role_ids', this.roleFilter.selectedRoleIds.join(','));
        localStorage.setItem('account_user_order_by', this.order_criteria);
        this.currentPage = page !== undefined ? page : this.currentPage;
        this.userService
            .getUsers(this.currentPage, this.page_size, this.filter, this.order_criteria, this.roleFilter.selectedRoleIds)
            .then((response) => {
            this.users = response.users;
            this.max_pages = response.pages;
            this.filtered_user_count = response.filtered_count;
            this.isLoading = false;
            this.setUserStatus(this.users);
        });
    }
    setUserStatus(users) {
        users.forEach((user) => {
            user.status = 'Registered';
            if (!user.confirmed && user.is_non_login_user) {
                user.status = 'Guest';
            }
            else if (!user.confirmed && !user.is_non_login_user) {
                user.status = 'Pending';
            }
        });
    }
    changePage(pageOffset) {
        const toPage = this.currentPage + pageOffset;
        if (toPage >= 0 && toPage < this.max_pages) {
            this.currentPage = toPage;
            this.updateUsers(toPage);
        }
    }
    async openModal(user) {
        this.modalOrgaFilter = '';
        this.modalModel.userRef = user;
        this.modalModel.role = user.is_admin ? 'Admin' : 'User';
        this.modalModel.user = user.user_id;
        this.modalModel.organization = user.organization_id;
        this.modalModel.is_deleted = user.is_deleted;
        this.modalModel.account_locked = user.account_locked;
        this.modalModel.two_factor_enabled = user.two_factor_enabled;
        // To disable checkbox when tfa not enabled because it can not be enabled by an admin
        this.modalModel.two_factor_enabled_state = user.two_factor_enabled;
        this.modalModel.unsuccessful_login_attempts = user.unsuccessful_login_attempts;
        this.modalModel.last_login = user.last_login;
        this.modalModel.role = null;
        this.modalModel.currentRoles = [];
        this.modalModel.rolesLoading = true;
        this.modalModel.is_terminal_user = user.is_terminal_user;
        this.modalModel.note = user.note;
        this.modalModel.organization_name = user.organization_name;
        // Set current organization - in order to be able to reset it
        currentOrganization = user.organization_id;
        await this.filterOrgas();
        this.userService.getOrgaRolesAndCurrentRole(user.user_id, user.organization_id).then((result) => {
            const roleResult = result || {};
            this.modalModel.availableRoles = roleResult.orgaRoles ? roleResult.orgaRoles : [];
            const userRoles = roleResult.currentRole ?? [];
            this.modalModel.currentRoles = userRoles;
            this.modalModel.role = userRoles[0]?.role_name;
            if (!this.modalModel.role) {
                this.modalModel.role = user.is_admin ? 'Admin' : 'User';
            }
            this.modalModel.rolesLoading = false;
        });
        this.userService.getAllUserLicenses(user.user_id).then((result) => {
            this.modalModel.licenses = result ?? [];
        });
        if (user.modalType === 'switchOrgaOnly') {
            document.getElementById('user_modal_orga_only').style.display = 'flex';
            document.getElementById('modalOrgaFilterInput').focus();
            document.body.style.overflow = 'hidden';
        }
        else {
            $('#user_modal').modal();
            this.$timeout(function () {
                $('#user_modal [ng-model="main.modalOrgaFilter"]').focus();
            }, 500);
        }
    }
    /**
     * True when the organization selected in the "In Organisation springen..." modal has not
     * granted Support Access. Drives the lock indicator and warning text; the Save button stays
     * enabled so bypass-permission holders can still switch (the backend enforces the block).
     */
    isSelectedOrganizationSupportAccessRevoked() {
        const selected = this.orgas.find((orga) => orga.organization_id === this.modalModel.organization);
        return isOrganizationSupportAccessRevoked(selected);
    }
    onModalClose(switchOrgaOnly = false) {
        if (this.modalModel.user === '') {
            this.modalModel.user = this.$scope.userId;
        }
        const update = switchOrgaOnly
            ? this.backendService.switchOrganizationAsSnapaddyAdmin(this.modalModel.organization)
            : this.userService.updateUser(this.modalModel);
        update.then(() => {
            // Only an actual organization switch of the acting user should notify other tabs.
            // A plain user update must not broadcast, otherwise it wrongly forces a reload elsewhere.
            if (switchOrgaOnly) {
                broadcastOrganizationSwitch('accounts.switchOrga', this.modalModel.organization);
            }
            document.getElementById('user_modal_orga_only').style.display = 'none';
            document.body.style.overflow = 'visible';
            this.updateUsers();
            window.location.reload();
        }, (error) => {
            this.handleSwitchError(error);
        });
    }
    backToMainOrganization() {
        const organizationId = window.__snapADDY.snapaddyOrganizationId;
        // Only dashboard users (super admins) get the snapAddy organization id injected,
        // and only they can reach this action; bail out defensively otherwise.
        if (!organizationId) {
            return;
        }
        this.backendService.switchOrganizationAsSnapaddyAdmin(organizationId).then(() => {
            broadcastOrganizationSwitch('accounts.backToMainOrga', organizationId);
            window.location.reload();
        }, (error) => this.handleSwitchError(error));
    }
    setOrgaFilter(orga_id) {
        localStorage.setItem('account_orga_filter', 'orga:' + orga_id);
    }
    handleSwitchError(error) {
        if (isSupportAccessDeniedError(error)) {
            window.alert('The customer has not granted Support Access. Please ask an organization administrator to grant access.');
            return;
        }
        if (isOrganizationMoveRequiresSwitchError(error)) {
            window.alert('Use the organization switch to move into another organization.');
            return;
        }
        window.alert('Oops! Something went wrong!');
    }
    deleteLicense(licenseId) {
        this.userService.deleteLicenseById(licenseId).then((response) => {
            if (response.data['affected'] === 0) {
                window.alert('No license was deleted.');
                return;
            }
            this.modalModel.licenses = this.modalModel.licenses.filter((it) => it.licenseId !== licenseId);
        }, (err) => {
            console.error('Failed to delete license', err);
            window.alert('The license could not be deleted properly.');
        });
    }
    async downloadFieldDefinitionsForUser(model) {
        try {
            const fieldDefinitionsResponse = await this.userService.getFieldDefinitionsForUserForSelectedCrm(model.user);
            this.downloadObjectAsJson(fieldDefinitionsResponse.data, `${new Date().toISOString().slice(0, 10)}-field-definitions-${model.userRef.profile.firstName}-${model.userRef.profile.lastName}`);
        }
        catch (error) {
            alert(JSON.stringify(error.data, undefined, 2));
            console.error('Failed to download field definitions', error);
        }
    }
    downloadObjectAsJson(object, fileName) {
        const jsonString = JSON.stringify(object, null, 2);
        const blob = new Blob([jsonString], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const anchor = document.createElement('a');
        anchor.href = url;
        anchor.download = fileName + '.json';
        anchor.click();
        // Clean up the URL and anchor element
        URL.revokeObjectURL(url);
    }
    setup() {
        const orgaMatches = /organization=(.*)/.exec(window.location.href);
        if (orgaMatches && orgaMatches.length > 0) {
            this.filter = decodeURIComponent(orgaMatches[1]);
        }
        try {
            this.page_size = parseInt(localStorage.getItem('account_user_page_size') ?? '25') || 25;
        }
        catch (e) {
            this.page_size = 25;
        }
        try {
            this.filter = localStorage.getItem('account_user_filter') || '';
        }
        catch (e) {
            this.filter = '';
        }
        try {
            const roleIds = localStorage.getItem('account_user_role_ids');
            if (roleIds) {
                this.roleFilter.selectRoleIds(roleIds.split(',').filter(Boolean).map(Number));
            }
        }
        catch (e) {
            this.roleFilter.clearSelection();
        }
        try {
            this.order_criteria = localStorage.getItem('account_user_order_by') || OrderUserBy.USER_NAME_ASC;
        }
        catch (e) {
            this.order_criteria = OrderUserBy.USER_NAME_ASC;
        }
        // skip initial load to not spam the database
        let initializing = true;
        const watchCallback = () => {
            if (!initializing) {
                this.updateUsers(0);
            }
            else {
                this.$timeout(function () {
                    initializing = false;
                });
            }
        };
        this.$scope.$watch(() => this.modalOrgaFilter, this.filterOrgas.bind(this));
        this.$scope.$watch(() => this.filter, watchCallback, true);
        this.$scope.$watch(() => this.page_size, watchCallback, true);
        this.$scope.$watch(() => this.order_criteria, watchCallback, true);
    }
};
UserController = __decorate([
    Component({
        selector: 'app-user-controller',
        // no associated template, is embedded static HTML-page in the server assets
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof UserControllerScope !== "undefined" && UserControllerScope) === "function" ? _a : Object, typeof (_b = typeof ng !== "undefined" && ng.ITimeoutService) === "function" ? _b : Object, Object, Object, Object])
], UserController);
export { UserController };
